import React, { useEffect, useState } from "react";
import { db } from "../../firebaseConfig"; // Your Firebase configuration file
import { collection, getDocs } from "firebase/firestore";
import { debounce } from "lodash"; // Import debounce from lodash
import { Link } from "react-router-dom";

const AdminDashboard: React.FC = () => {
  const [users, setUsers] = useState<any[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  // Fetching users from Firestore
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const userCollection = collection(db, "users");
        const snapshot = await getDocs(userCollection);
        const userList = snapshot.docs.map((doc) => ({
          id: doc.id,
          username: doc.data().username || "", // Default to empty string if undefined
          email: doc.data().email || "",       // Default to empty string if undefined
          score: doc.data().score || 0,        // Default to 0 if undefined
          referredFriends: doc.data().referredFriends || [], // Default to empty array if undefined
        }));
        setUsers(userList);
        setFilteredUsers(userList); // Initially show all users
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  // Handle search functionality with debounce
  const handleSearch = debounce((term: string) => {
    const filtered = users.filter(
      (user) =>
        user.username?.toLowerCase().includes(term.toLowerCase()) ||
        user.email?.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredUsers(filtered);
  }, 300); // Delay of 300ms

  // Handle input change
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    handleSearch(event.target.value); // Call debounce search
  };

  // Ensure that `filteredUsers` is available before rendering
  if (loading) {
    return <div className="text-white">Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-800 text-white p-6">
      <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>
      <div className="p-3">
      <Link to="/userDeposits">
        <button className="px-6 py-3 bg-blue-500 text-white rounded-md shadow-md hover:bg-blue-600 transition duration-300 ease-in-out">
          Deposits
        </button>
      </Link>
    </div>


    <div className="p-2">
      <Link to="/withdrawRequests">
        <button className="px-6 py-3 bg-blue-500 text-white rounded-md shadow-md hover:bg-blue-600 transition duration-300 ease-in-out">
          Withdraws
        </button>
      </Link>
    </div>
      {/* Search Input */}
      <div className="mb-6">
        <input
          type="text"
          value={searchTerm}
          onChange={handleChange}
          placeholder="Search by username or email"
          className="px-4 py-2 w-full sm:w-1/3 border rounded-md shadow-sm bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Display Total Users */}
      <h3 className="text-lg mb-4">Total Users: {filteredUsers.length}</h3>

      {/* Display Users */}
      {filteredUsers.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {filteredUsers.map((user) => (
            <div
              key={user.id}
              className="bg-gray-900 shadow-lg rounded-lg overflow-hidden"
            >
              <div className="p-4">
                <h3 className="font-semibold text-xl">{user.username}</h3>
                <p className="text-gray-400">{user.email}</p>
                <p className="mt-2 text-gray-500">Friends: {user.referredFriends.length}</p>
                <p className="mt-2 text-gray-500">Score: {user.score}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No users found.</p>
      )}
    </div>
  );
};

export default AdminDashboard;
